const ChevronDownIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.75 0.750111C12.75 0.750111 8.3311 6.75006 6.75 6.75006C5.1688 6.75006 0.75 0.750061 0.75 0.750061"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default ChevronDownIcon;
